import './policies/scripts'